import { scrollPos, windowHeight, windowWidth } from '../dimensions'
import getBcr from '../utils/getBcr'
import Observable from '../utils/Observable'
import setTransform from '../utils/setTransform'

function getVisiblePct (bcr, windowHeight) {
  if (bcr.top > windowHeight) return 0
  if (bcr.bottom < 0) return 0
  const visibleTop = Math.max(0, bcr.top)
  const visibleBottom = Math.min(windowHeight, bcr.top + bcr.height)
  return (visibleBottom - visibleTop) / windowHeight
}

jQuery($ => { $('.extreme-stage').each(function () {

  const container = $(this)
  const sections = container.find('.xr-slide')
  const scrollBarItems = container.find('.xr-scrollbar a')


  // =========== Hebe die aktuelle Leuchte hervor
  const sectionPositions = Observable.combine(sections.toArray().map(getBcr))

  const sectionPcts = Observable.combine([sectionPositions, windowHeight], ([positions, windowHeight]) => {
    return positions.map(bcr => getVisiblePct(bcr, windowHeight))
  })

  const currentSectionIndex = sectionPcts.map(pcts => {
    let maxIndex = 0
    let maxValue = 0
    for (let i = 0; i < pcts.length; i++) {
      if (pcts[i] >= maxValue) {
        maxIndex = i
        maxValue = pcts[i]
      }
    }
    return maxIndex
  })

  const currentSection = currentSectionIndex.map($.fn.eq.bind(sections))

  currentSection.watch(section => {
    scrollBarItems.parent().removeClass('active')
    scrollBarItems.filter('[href="#' + section.attr('id') + '"]').parent().addClass('active')
  })

  // =========== Scolle bei klick in der Navigationsleiste shön zu Leuchte
  const scrollTo = (section, complete, toEnd) => {
    let top = $(section).offset().top
    if (toEnd) top += $(section).outerHeight() - innerHeight
    $('html, body').stop().animate({
      scrollTop: top
    }, {
      duration: 600,
      complete
    })
  }
  scrollBarItems.click(function (e) {
    e.preventDefault()
    scrollTo($(this).attr('href'))
  })

  // =========== Halte die Scrollleiste und den Scroll-Hinweis immer innerhalb der Section
  Observable.combine([windowHeight, getBcr(container)], ([wh, bcr]) => {
    if (bcr.top > 55)
      return bcr.top - 55
    return Math.max(0, wh - bcr.bottom)
  })
    .map(x => `translate3d(0, ${-x}px, 0)`)
    .watch(setTransform(
      container.find('.xr-scrollbar, .xr-scrollbar__hint, .extreme-stage-x')
    ))
  
  // =========== Verstecke den ScrollbarHint, wenn gescrollt wurde
  getBcr(container)
    .map(x => x.top < -100)
    .watch($.fn.toggleClass.bind(
      container.find('.xr-scrollbar__hint'), 
      'xr-scrollbar__hint--hidden'
    ))

  // =========== Kontrolliere die ScrollPosition
  let containerBcr = getBcr(container)


  let animatingScroll = false
  let preventAdvance = false
  let scrollTimeout;
  let advanceTimeout;
  let readjustTimeout
  const scrollTimeoutSet = (duration) => {
    clearTimeout(scrollTimeout)
    animatingScroll = true
    scrollTimeout = setTimeout(() => animatingScroll = false, duration)
  }
  const advanceTimeoutSet = (duration) => {
    clearTimeout(advanceTimeout)
    preventAdvance = true
    advanceTimeout = setTimeout(() => preventAdvance = false, duration)
  }
  const advance = (dir = 1, timeout = 600) => {
    clearTimeout(readjustTimeout)
    const index = currentSectionIndex.get() + dir
    if (index >= 0 && index < sections.length) {
      scrollTimeoutSet(600)
      advanceTimeoutSet(timeout)
      scrollTo(sections.eq(index), () => {})
      return true
    }
    return false
  }
  const scrollBy = (delta, timeout) => {
    clearTimeout(readjustTimeout)
    if (animatingScroll) return
    //const nextPos = scrollPos.get() + delta

    let currentBcr = sectionPositions.get()[currentSectionIndex.get()]

    const lastBcr = sectionPositions.get()[sectionPositions.get().length - 1]
    if (lastBcr.bottom < 0) {
      window.scrollBy(0, delta)
      return;
    }

    if (delta > 0) {
      // Der Nutzer scrollt nach unten
      const maxDelta = Math.max(0, currentBcr.bottom - windowHeight.get())

      if (maxDelta < 5 && delta > 5) {
        if (preventAdvance || advance(1, timeout)) {
          return
        } else {
          window.scrollBy(0, delta)
          return
        }
      }
      if (delta > maxDelta) {
        window.scrollBy(0, maxDelta)
        if (delta > 5) scrollTimeoutSet(timeout)
        return
      }
    } else {
      // Der Nutzer scrollt nach oben
      const minDelta = Math.min(0, currentBcr.top)
      if (minDelta > -5 && !preventAdvance && delta < -5) {
        if (preventAdvance || advance(-1, timeout)) {
          return
        } else {
          window.scrollBy(0, delta)
          return
        }
      }
      if (delta < minDelta) {
        window.scrollBy(0, minDelta)
        if (delta < -5) scrollTimeoutSet(timeout)
        return
      }
    }

    window.scrollBy(0, delta)
  }
  
  $(document).on('wheel', e => {
    let delta = e.originalEvent.deltaY
    let timeout = 800
    if (e.originalEvent.deltaMode === 1) {
      delta *= 18
      timeout = 600
    }

    e.preventDefault()
    scrollBy(delta, timeout)
  })

  // const position = (event) => {
  //   if ('touches' in event) {
  //     return [
  //       event.touches[0].clientX,
  //       event.touches[0].clientY,
  //     ]
  //   }
  //   if ('clientX' in event)
  //     return [event.clientX, event.clientY]
  //   return [0, 0]
  // }
  // let touchLastY
  // let touchMoving = false
  // container.get(0).addEventListener('touchstart', e => {
  //   if (windowWidth.get() <= 500) return;
  //   let [x, y] = position(e)
  //   touchLastY = y
  //   touchMoving = true
  // }, { passive: false })
  // container.get(0).addEventListener('touchmove', e => {
  //   if (windowWidth.get() <= 500) return;
  //   if (!touchMoving) return
  //   e.preventDefault()
  //   let [x, y] = position(e)
  //   const delta = touchLastY - y
  //   touchLastY = y
  //   scrollBy(delta, 400)
  // }, { passive: false })
  // container.get(0).addEventListener('touchend', e => {
  //   touchMoving = false
  // }, { passive: false })

  const adjust = () => {
    const pct = sectionPcts.get()[currentSectionIndex.get()]
    if (pct < 1 && pct > 0.5 && currentSectionIndex.get() < sections.length - 1) {
      if (currentSection.get().offset().top > 0) {
        scrollTo(currentSection.get())
      } else {
        scrollTo(currentSection.get(), undefined, true)
      }
    }
  }
  $(document).on('scroll touchend', e => {
    clearTimeout(readjustTimeout)
    readjustTimeout = setTimeout(adjust, 800)
  })
  $(window).resize(() => {
    clearTimeout(readjustTimeout)
    readjustTimeout = setTimeout(adjust, 410)
  })

  // Mache extrem und extremer zu buttons
  const extremer = container.find('.xr-scrollbar__label--top').click(() => advance(-1, 400))
  const extrem = container.find('.xr-scrollbar__label--bottom').click(() => advance(1, 400))
  currentSectionIndex.watch(i => {
    extremer.toggleClass('xr-scrollbar__label--disabled', i === 0)
    extrem.toggleClass('xr-scrollbar__label--disabled', i >= sections.length - 1)
  })

}) })